import {
  API_BASE_URL,
  ASSETS_URL,
  STATIC_ASSETS_URL,
  isFilesCookieEnabled,
} from "./consts"
import { isBabeleHost } from "./cookies"
import { useAppStore } from "@src/state"

const isAssetPath = (path: string) => /^[\\/]?assets[\\/]/.test(path)

const isPrivateAssetPath = (path: string) =>
  /^[\\/]?assets[\\/]private[\\/]/.test(path)

// Host that serves a stored file path. assets/ paths are served by the API
// (the assets hosts only serve legacy Images paths). Off babele hosts (a
// custom domain), the filesToken cookie stays on the current host, so private
// files go through the app's own /assets/private proxy.
export const assetsHostFor = (path: string): string => {
  if (!isAssetPath(path)) return ASSETS_URL
  if (isFilesCookieEnabled() && !isBabeleHost() && isPrivateAssetPath(path))
    return window.location.origin
  return API_BASE_URL
}

// Absolute URLs saved earlier point at the old app, the custom domain, the
// assets host or the API. Re-point them at the host that serves their path now.
export const rehostSavedUrl = (url: string): string | undefined => {
  const { customDnsHost } = useAppStore.getState()
  const hosts = ["https://app.babele.co", ASSETS_URL, STATIC_ASSETS_URL]
  if (customDnsHost) hosts.push(`https://${customDnsHost}`)

  const host = hosts.find((h) => url.startsWith(h))
  if (!host) return undefined

  const path = url.slice(host.length)
  return `${assetsHostFor(path)}${path}`
}
